import React, { useState } from 'react';

import TextField, { TextFieldProps } from '@material-ui/core/TextField';

import { isEmail } from '../util/string-validators';

type InputProps = {
  // Our configurations
  onError?: (error: string | null) => void;
  customAdornment?: JSX.Element;
  errorText?: string | null;
  // Configurations that are both on our configurations and added by React, but that we override
  value: string | null;
  onChange: (newValue: string) => void;
};

type Props = InputProps & Omit<TextFieldProps, keyof InputProps>;

export const UiTextField = ({
  label,
  required,
  value,
  onChange,
  onError,
  customAdornment,
  errorText,
  helperText,
  type,
  ...textFieldProps
}: Props) => {
  const [textInputError, setTextInputError] = useState<string | null>(null);

  const onBlurHandler = () => {
    if ((!required && !value) || (required && value)) {
      setTextInputError(null);
      if (onError) {
        onError(null);
      }
    }

    if (required && !value) {
      setTextInputError('Required');
      if (onError) {
        onError('Required');
      }
    }

    if (type === 'email' && value && !isEmail(value)) {
      setTextInputError('Please enter a valid email');
      if (onError) {
        onError('Please enter a valid email');
      }
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = e.target;
    if (newValue && required && textInputError) {
      setTextInputError(null);
    }
    onChange(newValue);
  };

  return (
    <TextField
      value={value}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      error={Boolean(textInputError)}
      helperText={textInputError || errorText || helperText}
      // Passthrough options
      label={label}
      required={required}
      type={type}
      {...textFieldProps}
    />
  );
};
